/**
 * ObjectSequenceField React component
 * 
 * @author    Jens Gruschel
 * @copyright © 2020 contexagon GmbH
 */


// React
import React from 'react';
import PropTypes from 'prop-types';
import connect from "react-redux/es/connect/connect";

// Material UI
import {withStyles} from "@material-ui/core";

// Material UI components
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from "@material-ui/core/Tooltip";

// icons
import RedoIcon from '@material-ui/icons/Redo';

// application
import {requestNextSequenceValue} from "../../operations/sequences";
import {showError} from "../../operations/message";


export class ObjectSequenceField extends React.Component {

    state = {
        requesting: false
    }

    handleChange = (id) => event => {
        const value = event.target.value === "" ? undefined : event.target.value;
        this.props.onObjectValueChange(id, value);
    };

    validateText(acceptMissing) {
        if (this.props.value == null || this.props.value === "") {
            return acceptMissing || !this.props.fieldDef.mandatory;
        }
        else {
            return true;
        }
    }

    render() {

        const { classes, fieldDef } = this.props;

        const value = this.props.value;

        let inputLabelProps = {};
        let inputProps = {
            readOnly: this.props.readOnly,
            endAdornment: <InputAdornment position="end">
                <IconButton
                    aria-label="generate new number"
                    onClick={() => this.requestNextSequenceValue()}
                    disabled={this.state.requesting}
                >
                    <Tooltip title="neue Nummer erzeugen"><RedoIcon/></Tooltip>
                </IconButton>
            </InputAdornment>
        };

        return <TextField
            className={classes.textField}
            id={fieldDef.id}
            label={fieldDef.name}
            value={value != null ? value : ""}
            disabled={this.props.readOnly} // TODO: make text selectable for copy/paste
            required={fieldDef.mandatory}
            error={!this.validateText(true)}
            onChange={this.handleChange(fieldDef.id)}
            margin="normal"
            multiline={false}
            fullWidth={true}
            type="text"
            helperText={fieldDef.note}
            InputLabelProps={inputLabelProps}
            InputProps={inputProps}
            variant="standard"
        />;
    }

    async requestNextSequenceValue() {
        this.setState({requesting: true});
        try {
            const { fieldDef } = this.props;
            const value = await requestNextSequenceValue(fieldDef, this.props.accessToken);
            this.props.onObjectValueChange(fieldDef.id, value);
        }
        catch (error) {
            this.props.showError(error);
        }
        this.setState({requesting: false});
    }
}

ObjectSequenceField.propTypes = {
    onObjectValueChange: PropTypes.func.isRequired,
    fieldDef: PropTypes.object.isRequired,
    objectId: PropTypes.string,
    readOnly: PropTypes.bool,
    value: PropTypes.any
};

const styles = {
    textField: {
        // red star for mandatory fields
        "& label span": {
            color: "#FF0000"
        }
    }
};

const mapStateToProps = state => {
    return {
        accessToken: state.authorization.accessToken
    };
};

export default connect(mapStateToProps, {showError})(withStyles(styles)(ObjectSequenceField));